import React, { useEffect, useState } from 'react';
import { usePoolCreation } from '../hooks';
import { useTokenPrice } from '../../../hooks/useTokenPrice';
import { useAccount } from 'wagmi';
import { formatAddress } from '../../../helper';
import { useTheme } from '../../../hooks/ThemeProvider';

const FinalizeStep = ({ formData, tokenSymbol, currentStep }) => {
    const durationInDays = formData.poolEndDate
        ? Math.ceil((formData.poolEndDate - new Date()) / (1000 * 60 * 60 * 24))
        : 0;

    const [gasEstimate, setGasEstimate] = useState(null);
    const [showGasEstimate, setShowGasEstimate] = useState(false);
    const [usdValue, setUsdValue] = useState(0);

    const { address: account } = useAccount();
    const { isCreatingPool, isEstimatingGas, createPool, estimatePoolCreationGas } = usePoolCreation();
    const {price:ethPrice} = useTokenPrice('0x0000000000000000000000000000000000000000');
    const { theme } = useTheme();

    const handleEstimateGas = async () => {
        try {
            setShowGasEstimate(true);
            const estimate = await estimatePoolCreationGas(
                account,
                formData.rewardToken,
                formData.totalRewards,
                formData.poolEndDate,
                formData.tokenDecimals
            );
            setGasEstimate(estimate);
        } catch (error) {
            console.error('Gas estimation failed:', error);
            setGasEstimate(null);
        }
    };

    // Run gas estimation when dependencies change
    useEffect(() => {
        if (account) {
            handleEstimateGas();
        }
    }, [formData, account]);

    // Separate effect to calculate USD value
    useEffect(() => {
        if (gasEstimate?.totalGasCostETHFormatted && ethPrice) {
            const calculatedUsdValue =
                parseFloat(gasEstimate.totalGasCostETHFormatted) * ethPrice;
            setUsdValue(calculatedUsdValue);
        } else {
            setUsdValue(0);
        }
    }, [gasEstimate, ethPrice]);

    // console.log('Gas Estimate:', gasEstimate, 'USD Value:', usdValue);

    return (
        <div className="wrappermain">

            <div className="textformobile">
                <div className="parentmbl d-none">
                    <div className="parent">
                        <h6>Finalize</h6>
                        <button>3/3</button>
                    </div>
                </div>
            </div>

            <div className="mainboxmain">
                <img
                    src={formData.logoPreview ? formData.logoPreview : "/assets/blurimage.png"}
                    alt="img"
                    className="img-fluid blurimg"
                />
                <div className="midcontant">
                    <span>
                        {formData.logoPreview ? (
                            <img
                                src={formData.logoPreview}
                                className="imggginner1"
                                style={{ objectFit: 'cover' }}
                                alt="Project logo"
                            />
                        ) : (
                            <img src="/assets/up.svg" className="imggginner1" alt="placeholder" />
                        )}
                    </span>
                    <h4>{formData.projectName}</h4>
                </div>
            </div>

            <div className="communitybox">
                <h2>{formData.tagline}</h2>
                <p>{formData.poolDescription}</p>
                <div className="fourbtns">
                    {formData.website && (
                        <button>
                            {theme === 'dark'
                                ? <img src="/assets/web.svg" alt="website" />
                                : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6Z"
                                            fill="#000F2F"
                                        />
                                    </svg>
                                )
                            }
                            {formatAddress(formData.website)}
                        </button>
                    )}

                    {formData.twitter && (
                        <button>
                            {theme === 'dark'
                                ? <img src="/assets/twitter.svg" alt="twitter" />
                                : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
                                        <path
                                            d="M8.95803 0.857178H10.5352L7.08949 5.21411L11.1431 11.1429H7.96918L5.48321 7.54712L2.6387 11.1429H1.06053L4.7461 6.48268L0.857422 0.857178H4.11196L6.35906 4.14387L8.95803 0.857178Z"
                                            fill="#000F2F"
                                        />
                                    </svg>
                                )
                            }
                            {formatAddress(formData.twitter)}
                        </button>
                    )}

                    {formData.instagram && (
                        <button>
                            {theme === 'dark'
                                ? <img src="/assets/instagram.svg" alt="instagram" />
                                : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
                                        <path
                                            d="M6.00028 4.35432C6.90918 4.35432 7.64599 5.09113 7.64599 6.00003C7.64599 6.90894 6.90918 7.64575 6.00028 7.64575C5.09138 7.64575 4.35456 6.90894 4.35456 6.00003C4.35456 5.09113 5.09138 4.35432 6.00028 4.35432Z"
                                            fill="#000F2F"
                                        />
                                    </svg>
                                )
                            }
                            {formatAddress(formData.instagram)}
                        </button>
                    )}

                    {formData.discord && (
                        <button>
                            {theme === 'dark'
                                ? <img src="/assets/instagram.svg" alt="discord" />
                                : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
                                        <path
                                            d="M3.88817 1.71436C3.48171 1.71436 2.25628 2.19409 2.03643 2.28997C1.81658 2.38584 1.57255 2.68513 1.29566 3.17908C1.01838 3.67304 0.795889 4.25047 0.434379 5.09985C0.0732474 5.94923 -0.0109915 7.58675 0.00109663 8.08654C0.0131847 8.58633 0.0724919 8.97675 0.603235 9.27239C1.1336 9.56767 1.60277 9.8768 2.09649 10.0627C2.59059 10.2486 2.92755 10.3824 3.15647 10.1965C3.38538 10.0106 3.53611 9.68505 3.53611 9.68505C3.53611 9.68505 3.75294 9.39451 3.34345 9.22026C2.93397 9.04565 2.72923 8.92353 2.74698 8.74344C2.76511 8.56336 2.79496 8.46457 2.89733 8.4879C2.9997 8.51123 3.24108 8.92936 4.16847 9.12111C5.09585 9.31286 5.99981 9.28406 5.99981 9.28406C5.99981 9.28406 6.90415 9.31322 7.83153 9.12111C8.75892 8.92936 8.99992 8.51123 9.10229 8.4879C9.20467 8.46457 9.23451 8.56336 9.25264 8.74308C9.27077 8.92353 9.06603 9.04565 8.65655 9.22026C8.24706 9.39451 8.46389 9.68505 8.46389 9.68505C8.46389 9.68505 8.61462 10.0102 8.84353 10.1965C9.07207 10.3824 9.40941 10.2486 9.90313 10.0627C10.3969 9.8768 10.8664 9.56804 11.3968 9.27239C11.9275 8.97675 11.9868 8.58633 11.9989 8.08654C12.011 7.58712 11.9268 5.94923 11.5652 5.09985C11.2041 4.25047 10.9812 3.67304 10.704 3.17908C10.4275 2.68513 10.183 2.38584 9.96357 2.2896C9.74372 2.19409 8.51791 1.71436 8.11145 1.71436C7.70499 1.71436 7.58486 1.98776 7.58486 1.98776L7.4432 2.28997C7.4432 2.28997 6.49127 2.11535 6.00623 2.11499C5.5212 2.11499 4.5568 2.28997 4.5568 2.28997L4.41514 1.9874C4.41514 1.9874 4.29501 1.71436 3.88817 1.71436Z"
                                            fill="#000F2F"
                                        />
                                    </svg>
                                )
                            }
                            {formatAddress(formData.discord)}
                        </button>
                    )}
                </div>
            </div>

            <div className="tokenbox ">
                <div className="parenttoken">
                    <div className="left">
                        <h2>Reward Token</h2>
                    </div>
                    <div className="right">
                        <p>{formData.rewardToken.slice(0, 10)}...{formData.rewardToken.slice(-6)}</p>
                        <button>{tokenSymbol}</button>
                    </div>
                </div>

                <div className="parenttoken">
                    <div className="left">
                        <h2>Total Rewards </h2>
                    </div>
                    <div className="right">
                        <p>{formData.totalRewards}</p>
                        <img
                            style={{ width: '14px', height: '14px', borderRadius: '50%' }}
                            src={formData.logoPreview ? formData.logoPreview : "/assets/img.png"}
                            alt="img"
                            className="img-fluid"
                        />
                    </div>
                </div>

                <div className="parenttoken">
                    <div className="left">
                        <h2>Pool End Date & Time</h2>
                    </div>
                    <div className="right">
                        <p>{formData.poolEndDate?.toLocaleString()}</p>
                    </div>
                </div>
            </div>

            <div className="feebox">
                <p className="gaspara">Gas Fees</p>
                <h2>
                    ${usdValue ? usdValue.toFixed(5) : 0} ({gasEstimate?.totalGasCostETHFormatted || 0} ETH)
                </h2>
            </div>

            <div className="yellowbox">
                <p>
                    You are creating a Root Pool distributing {formData.totalRewards} tokens
                    over {durationInDays} days. This cannot be changed later.
                </p>
            </div>
        </div>
    );
};

export default FinalizeStep;
